"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevisionAlg = void 0;
const student_1 = require("../src/student");
const strategy_1 = require("../src/strategy");
// import { input } from '@inquirer/prompts';
const tools_1 = require("./tools");
const ai_toolkit_1 = require("@evidenceb/ai-toolkit");
// const prompt = require("prompt-sync")();
class RevisionAlg extends ai_toolkit_1.AIEngine {
    constructor(params = {}) {
        super(params);
        this.current_bandit_state = undefined; //bandit_state of current sample
        this.simulation_date = undefined;
        //spread argument must be declared as tuple
        let studp = [[], {}, [], [], [], [], [], [], {}];
        if (("student_params" in this.params)) {
            studp = this.params.student_params;
        }
        this.moduleId = this.params.graph.main_act;
        this.student = new student_1.HalfLifeStudent(...studp);
        this.strategy = new strategy_1.StrategyTheta(this.student);
        this.sequence = [];
        this.obj_count = 0;
        this.obj_sampled = undefined;
        this.act_sampled = undefined;
        this.simulation_date = undefined;
    }
    set_simulation_date(date) {
        this.simulation_date = date;
    }
    //verify revision space is not empty
    isRevisionAvailable(min_act = 3) {
        return Object.keys(this.student.dict_idx_ob_act()).length >= min_act;
    }
    // add_objective(objective: string, activities: string[], diff_act: number[], date: Date): void {
    //   this.student.add_objective(objective, activities, diff_act, date);
    // }
    add_activity(objective, activity, diff_act, date) {
        this.student.add_activity(objective, activity, diff_act, date);
    }
    /*
       * Check bandit state from zpdes and add the closed activity to revision space
       * @param bandit_state
       * @param ontology served for "get_objectiveID_of_activity" function
       * @param date
       */
    check_zpdes_state_and_add_activity(bandit_state, ontology, date) {
        if (this.current_bandit_state != undefined) {
            for (let objOrActId in bandit_state) {
                if (bandit_state[objOrActId] == 2 && this.current_bandit_state[objOrActId] != bandit_state[objOrActId] && !ontology.objectives.includes(objOrActId)) {
                    let actId = objOrActId;
                    let objId = ontology.get_objectiveID_of_activity(actId);
                    const diff_act = ontology.computeLinearDifficulties(); //getLinearDiff in ontology
                    this.add_activity(objId, actId, diff_act[actId], date);
                }
            }
        }
        this.current_bandit_state = (0, tools_1.deepCopy)(bandit_state);
    }
    init_from_history(history_act_to_add) {
        for (let nn = 0; nn < history_act_to_add.length; nn++) {
            let act = history_act_to_add[nn];
            this.add_activity(act.objective, act.activity, act.diff_act, act.date);
        }
    }
    base_update(objective, activity, answer, date) {
        this.strategy.update(objective, activity, answer, date);
        if (0 <= answer && answer <= 1) {
            this.sequence.push([objective, activity, answer]);
        }
        else {
            //if simulation generate answer from half-life model
            const simulation = this.student.student_answer(objective, activity, date);
            this.sequence.push([objective, activity, simulation]);
        }
    }
    update(interaction) {
        return this.base_update(interaction.objectiveId, interaction.activityId, interaction.score, interaction.timestamp);
    }
    update_history(history) {
        let date = new Date();
        if (this.simulation_date != undefined) {
            date = this.simulation_date;
        }
        for (let nn = 0; nn < history.length; nn++) {
            this.update(history[nn]);
        }
    }
    nextActivity() {
        let date = new Date();
        if (this.simulation_date != undefined) {
            date = this.simulation_date;
        }
        let objActSampled = this.sample_with_objective_count(date);
        let activityInfo = {
            "moduleId": this.moduleId,
            "objectiveId": objActSampled[0],
            "activityId": objActSampled[1],
        };
        return activityInfo;
    }
    sample(date = new Date(), interval_softmax = 5) {
        const [ob, act] = this.strategy.select_activity(interval_softmax, date);
        return [ob, act];
    }
    sampleWithFixedObj(ob, date = new Date()) {
        const [ob_select, act] = this.strategy.select_activity_ob(ob, date);
        return [ob, act];
    }
    sample_from_history(past_history) {
        this.update_history(past_history);
        return this.nextActivity();
    }
    isCurriculumFinished() {
        return false;
    }
    sample_with_objective_count(date = new Date(), interval_softmax = 5) {
        //if sequence is vide 
        if (this.obj_count == 0) {
            let obj_activity_to_update = this.sample(date, interval_softmax);
            this.obj_sampled = obj_activity_to_update[0];
            this.act_sampled = obj_activity_to_update[1];
            this.obj_count++;
        }
        else {
            let obj_activity_to_update = this.sampleWithFixedObj(this.obj_sampled, date);
            this.act_sampled = obj_activity_to_update[1];
            this.obj_count++;
            if (this.obj_count >= this.student.obj_params[this.obj_sampled].nb_stay) {
                this.obj_count = 0;
            }
        }
        return [this.obj_sampled, this.act_sampled, date];
    }
    get_student_diagnosis() {
        let date = new Date();
        if (this.simulation_date != undefined) {
            date = this.simulation_date;
        }
        let diagnostic_dict = {};
        diagnostic_dict["objectiveSpace"] = this.student.objectives;
        diagnostic_dict["acitivtySpace"] = [].concat(...Object.values(this.student.activities));
        diagnostic_dict["activityProbas"] = {};
        for (var i = 0; i < this.student.diff_act.length; i++) {
            for (var j = 0; j < this.student.diff_act[i].length; j++) {
                var activityKey = this.student.activities[diagnostic_dict["objectiveSpace"][i]][j];
                var probValue = this.student.generate_prob(date)[i][j];
                diagnostic_dict["activityProbas"][activityKey] = probValue;
            }
        }
        return diagnostic_dict;
    }
}
exports.RevisionAlg = RevisionAlg;
